import React, { createContext, useContext, useState, useCallback } from 'react';

const EncounterContext = createContext(null);

export function EncounterProvider({ children }) {
  const [activeEncounter, setActiveEncounter] = useState(null);
  const [transcriptBuffer, setTranscriptBuffer] = useState([]);
  const [aiOutputs, setAiOutputs] = useState(null);
  const [noteState, setNoteState] = useState(null);

  const startEncounter = useCallback((encounter) => {
    setActiveEncounter(encounter);
    setTranscriptBuffer(encounter?.transcript?.chunks || []);
    setNoteState(encounter?.note || null);
    setAiOutputs(encounter?.encounter_outputs || null);
  }, []);

  const updateEncounter = useCallback((data) => {
    setActiveEncounter(prev => ({ ...prev, ...data }));
    if (data.transcript) setTranscriptBuffer(data.transcript.chunks || []);
    if (data.note) setNoteState(data.note);
    if (data.encounter_outputs) setAiOutputs(data.encounter_outputs);
  }, []);

  const clearEncounter = useCallback(() => {
    setActiveEncounter(null);
    setTranscriptBuffer([]);
    setAiOutputs(null);
    setNoteState(null);
  }, []);

  const addTranscriptChunk = useCallback((chunk) => {
    setTranscriptBuffer(prev => [...prev, chunk]);
  }, []);

  return (
    <EncounterContext.Provider value={{
      activeEncounter, transcriptBuffer, aiOutputs, noteState,
      startEncounter, updateEncounter, clearEncounter, addTranscriptChunk,
      setAiOutputs, setNoteState,
    }}>
      {children}
    </EncounterContext.Provider>
  );
}

export const useEncounter = () => useContext(EncounterContext);
